import React from 'react';
import moment from 'moment';
import {ContainerFileDinhKem} from 'components/upload';
import {Text} from 'components/tt-forms/common';
import {ShowIf} from 'components/utils';

class ThongTinYeuCauKiemTraDeXuat extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon,
      donViGiaoKTDX: this.props.donViGiaoKTDX,
      donViPhoiHops: this.props.donViPhoiHops,
      ngayBaoCaoKQ: this.props.ngayBaoCaoKQ,
      hideTable: this.props.hideTable
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      listTaiLieuVanThuGiaiQuyetDon: nextProps.listTaiLieuVanThuGiaiQuyetDon,
      donViGiaoKTDX: nextProps.donViGiaoKTDX,
      donViPhoiHops: nextProps.donViPhoiHops,
      ngayBaoCaoKQ: nextProps.ngayBaoCaoKQ,
      hideTable: nextProps.hideTable
    })
  }

  getDonViPhoiHop(arr){
    let dataReturn = '';
    arr.map((state, i) => {
      if (i == 0) {
        dataReturn = dataReturn + state.ten
      } else {
        dataReturn = dataReturn + ', ' + state.ten
      }
    })
    return dataReturn;
  }

  render() {
    return (
      <section className="wrap-block">
        <h2 className="title-14 mb15">Thông tin yêu cầu kiểm tra đề xuất</h2>
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter mb15">
            <Text className="col-25" label="Đơn vị giao kiểm tra đề xuất:" value={this.state.donViGiaoKTDX ? this.state.donViGiaoKTDX.ten : ''}/>
            {/* <Text className="col-25" label="Đơn vị phối hợp:" value={this.state.donViPhoiHops.length > 0 ? this.getDonViPhoiHop(this.state.donViPhoiHops) : ''}/> */}
            <Text className="col-25" red={true} label="Thời gian báo cáo kết quả:" value={this.state.ngayBaoCaoKQ ? moment(this.state.ngayBaoCaoKQ).format('DD/MM/YYYY') : ''}/>
          </div>
          <ShowIf condition={!this.state.hideTable}>
            <div className="col-100 pb5 no-gutter">
              <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.state.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true}/>
            </div>
          </ShowIf>
        </div>
      </section>
    );
  }
}

ThongTinYeuCauKiemTraDeXuat.defaultProps = {
  listTaiLieuVanThuGiaiQuyetDon: [],
  donViGiaoKTDX: {},
  donViPhoiHops: [],
  ngayBaoCaoKQ: '',
  hideTable: false
}

export default ThongTinYeuCauKiemTraDeXuat;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/ThongTinYeuCauKiemTraDeXuat.jsx